module.exports = __webpack_public_path__ + "media/images/but-how-it-works-e11c38e0.gif";